import React from "react";
import { connect } from "react-redux";

import PageHeader from "../page/page-header";
import LayoutWithFooter from "../page/layout-with-footer";
import { getBrand } from "../brand/brand-selectors";
import { default as SignUpForm } from "../auth/sign-up-page";
import AppSecondaryBackground from "../root/app-secondary-background";

function SignUpPage({ brand }) {
  return (
    <AppSecondaryBackground>
      <LayoutWithFooter
        className="guidance SignUpPage"
        contentClassName="SignUpPage__Content"
      >
        <PageHeader className={"SignUpPage__Header"} logo={brand.imagePost} />
        <SignUpForm />
      </LayoutWithFooter>
    </AppSecondaryBackground>
  );
}

const mapState = state => ({
  brand: getBrand(state)
});

SignUpPage = connect(mapState)(SignUpPage);

export default SignUpPage;



// WEBPACK FOOTER //
// ./src/modules/pages/SignUpPage.js